import Signal from 'ln/signal/Signal';

interface MomentEvent {
	time:number;
}

interface PeriodEvent {
	startTime:number;
	endTime:number;
}

interface EventCallback {
	( event:MomentEvent|PeriodEvent ):void;
}

/**
 * Monitors a time update event to check if some time events should be risen or not. 
 */
class TimeMonitor {

	private active:Array<MomentEvent|PeriodEvent>;
	private all:Array<MomentEvent|PeriodEvent>;
	private lastTime:number;

	public start:Signal<EventCallback> = new Signal<EventCallback>();
	public stop:Signal<EventCallback> = new Signal<EventCallback>();

	public minDelta:number = 0.1;

	constructor() {
		this.all = [];
		this.active = [];
		this.lastTime = 0;
	}

	/**
	 * Invoke this function or register it on a signal to check for time events
	 */
	update( time:number ) {

		// check for min time delta.
		if( this.minDelta > Math.abs( time - this.lastTime ) ) return;

		var buffer = [];

		// for i loop because user guard
		for( var i = 0; i < this.all.length; i++ ) {
			var event = this.all[i];

			if( this.isMoment( event ) && time >= event.time && this.lastTime <= event.time ) {
				buffer.push( event );
			}

			if( this.isPeriod( event ) && time > event.startTime && time < event.endTime ) {
				buffer.push( event );
			}
		}

		this.lastTime = time;
		this.sync( buffer );

	}

	/**
	 * Sets the array of events the monitor.
	 */
	setEvents( events:Array<MomentEvent|PeriodEvent> ) {
		this.all = events;
	}

	/**
	 * Synchronizes new events with existing ones and invokes the corresponding signals.
	 */
	private sync( newest:Array<MomentEvent|PeriodEvent> ) {

		// check for newly events
		newest.forEach( current => {
			if( this.active.indexOf( current ) < 0 ) this.start.dispatch( current );
		});

		// check for removed ones
		this.active.forEach( current => {
			if( newest.indexOf( current ) < 0 ) this.stop.dispatch( current );
		});

		// set new events
		this.active = newest;
	}


	private isMoment( e:any ):e is MomentEvent {
		return e.time !== undefined;
	}

	private isPeriod( e:any ):e is PeriodEvent {
		return e.startTime !== undefined && e.endTime !== undefined;
	}
}

export default TimeMonitor;